import { ColDef, Column, ColumnPinnedType, DateFilterModel, NumberFilterModel, ProvidedFilterModel, SetFilterModel, TextFilterModel } from "ag-grid-community";
import { CustomCellRendererProps } from "ag-grid-react";
import { ReactNode } from "react";

export type AgGridCellRendererFunc<TData = unknown, TValue = undefined, TContext = unknown> =
  (params: CustomCellRendererProps<TData, TValue, TContext>) => ReactNode;

export const dndHandleColumnId = "dndHandle";

export type ColumnParams = {
  columnId: string;
  width?: number;
  pinned?: ColumnPinnedType;
};

export type CommonColumnParamsState = {
  params: { [key: string]: ColumnParams };
  columns: string[];
};

export type ColumnWidth = {
  key: string | ColDef | Column;
  newWidth: number;
};

export type AgGridSingleFilterModel = ProvidedFilterModel & (DateFilterModel | NumberFilterModel | SetFilterModel | TextFilterModel);
